import { TRANSACTION_TYPE } from 'utils/constants';

export function getDiscountTextId(type: string): string {
  if (type === TRANSACTION_TYPE.SUBSCRIPTION_UPGRADE) {
    return 'transaction.refund';
  }

  return 'transaction.discount';
}
